import Joi from 'joi';

import { requiredString } from '../../../utils/validators';

const validationSchema = Joi.object({
  timezone: requiredString,
});

export default validationSchema;
